module.exports = __webpack_public_path__ + "img/J13162.1c94cec1.png";